<template>
  <div class="indicators">
    <div
      v-for="(item, index) in indicators"
      :key="'indicator' + index"
      class="item"
    >
      <div class="line-clamp-1 title">{{ item.title }}</div>
      <div
        v-if="item.html"
        class="data"
        v-html="item.html"
      ></div>
      <div
        v-else
        class="data"
      >
        <span class="value">
          {{ item.valueText }}
          <span class="unit">{{ item.unit }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed, reactive, nextTick, getCurrentInstance } from 'vue';
import { Button, Message, Input, Modal } from '@arco-design/web-vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import Definition from '@client/config/definition';
import { getSportSummary, getSportSummaryItems } from '@client/pages/activity-detail/config/sport.summary';
import { useActivityDetail } from '../../hooks/useActivityDetail';

const activityDetailStoreRef = activityDetailStore();
const { unitType } = useActivityDetail();

const vm = getCurrentInstance();
Message._context = vm?.appContext;
const summary = computed(() => activityDetailStoreRef.activityDetail?.summary);

// 定义每项运动分别有哪些概要字段显示
const indicators = computed(() => {
  const sportName = Definition.getSportNameByType(activityDetailStoreRef.sportType);

  // 体能测试
  const summaryKeys = getSportSummaryItems()['Test'];

  const items = getSportSummary({
    sportName,
    unitType: unitType.value,
    // 图表相关
    // 接口返回的y轴刻度定义
    graphObj: activityDetailStoreRef.graphObj,
    summary: summary.value
  });

  const result = [];
  summaryKeys.forEach((data) => {
    const key = data.key;
    const item = items[key];
    result.push({
      ...item,
      key,
      title: item.title,
      html: item.html || getDefaultHtml(item.valueText, item.unit) || ''
    });
  });
  return result;
});

function getDefaultHtml(value, unit) {
  return `
            <span class="value">
              ${value}
              <span class="unit">${unit || ''}</span>
            </span>`;
}
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.indicators {
  padding: 0 16px;
  //max-height: 300px;
  height: 100%;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 60px;
  grid-gap: 1px 1px;
  //background: rgba(255, 255, 255, 0.05);

  .item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    //background: #181e30;
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-sizing: border-box;

    &:nth-of-type(2n) {
      border-right: 0;
    }

    .title {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);

      .icon-analysis {
        width: 12px;
        cursor: pointer;
      }
    }

    .data {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      :deep(.value) {
        margin-left: -8px;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;

        .unit {
          position: absolute;
          top: 50%;
          left: 100%;
          transform: translate(0, -50%);
          margin-left: 4px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.4);
          word-break: keep-all;

          &.color-box {
            transform: translate(-17%, -50%) scale(0.66);
            height: 18px;
            line-height: 18px;
            padding: 0 2px;
            border-radius: 12px;
            font-size: 12px;
            white-space: nowrap;
            color: #ffffff;
            background: #12b1f5;
            //border: 1px solid #12b1f5;
          }

          &.time {
            top: 0;
            left: 100%;
            transform: translate(-10%, 0) scale(0.8);
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
../../config/sportSummary @client/pages/activity-detail/config/sport.summary
